import { useFilterRequestTypeContext } from "./filter-request-type.context";

export function FilterRequestType() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterRequestTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}